module.exports = __webpack_public_path__ + "static/alert-issue-do-498c525b19b9bf8b401c692e4a01c03d.png";